/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { Grid, Box } from '@mui/material';
import { getOrderById } from 'service';
import { useState, useEffect } from 'react';
import { strings } from 'i18n/Strings';
import { ReuseGrid } from 'components/shared';
import {
  CurrencyFormater,
  CurrencyFormatterAllDecimals,
} from 'components/helpers/commonFunctions/CurrencyFormater';
import {
  dateFormat,
  unitsAndAmountSplitStringFormater,
} from 'utils/GeneralUtil';
export interface OrderStatusInterface {
  mmOrderId: number;
  ibOrderId: string;
  orderStatus: string;
  totalUnits: string;
  orderDate: string;
  fundName: string;
  contractId: number;
  symbol: string;
  currentPrice: string;
  fundType: string;
  tradePrice: string;
  totalContribution: string;
  transactionMethod: string;
  transactionDate: string;
  transactionStatus: string;
}
export interface orderStatusProps {
  ibOrderId: number;
}
const OrderStatus = (props: orderStatusProps): JSX.Element => {
  const [planData, setPlanData] = useState<OrderStatusInterface>();
  const getAllPlanRequests = async (): Promise<void> => {
    try {
      const data = await getOrderById(props.ibOrderId);
      setPlanData(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    void getAllPlanRequests();
  }, []);

  return (
    <Grid item xs={8} sm={8} md={8} sx={{ marginBlock: 2 }}>
      <Box marginTop={1}>
        {<h3>{planData?.orderStatus}</h3>}
        {<p>{strings.displayText[planData?.orderStatus]}</p>}
      </Box>
      {planData &&
        Object.keys(planData)?.map((ele, i) => {
          if (ele === 'description') return null;

          const customName = strings.displayText[ele];
          let customerDetails = planData[ele];
          switch (ele) {
            case 'totalContribution':
              customerDetails = CurrencyFormater(
                unitsAndAmountSplitStringFormater(customerDetails, 2),
              );
              break;
            case 'tradePrice':
            case 'closePrice':
              customerDetails = CurrencyFormatterAllDecimals(
                Number(customerDetails),
              );
              break;
            case 'orderDate':
            case 'transactionDate':
              customerDetails = dateFormat(customerDetails);
              break;
            case 'totalUnits':
              customerDetails = unitsAndAmountSplitStringFormater(
                customerDetails,
                4,
              );
              break;
            case 'fundName':
              customerDetails = planData?.description;
              break;
            default:
              // For all other cases
              break;
          }

          return (
            <div key={i}>
              <ReuseGrid
                customName={customName}
                customerDetails={customerDetails}
              />
            </div>
          );
        })}
    </Grid>
  );
};
export default OrderStatus;
